var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_vm._t("loading"):_vm._e(),_c('div',{ref:"container",attrs:{"id":"viewerContainer"}},[_c('div',{staticClass:"pdfViewer",attrs:{"id":"viewer"}}),_c('resizeSensor',{attrs:{"initial":true},on:{"resize":_vm.resizeScale}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }